<div class="nv-progress-container">
    <div  class="nv-progress" [style.width]="progress + '%'">
    </div>   
</div> 